import { graphql } from "gatsby"
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import CardMinor from "@molecules/CardMinor/CardMinor"

const CardMinorGrid = ({ blockDataCardMinorGrid }) => {
  const { cards } = blockDataCardMinorGrid || {}

  const colClass = cards ? 12 / cards.length : null

  const cardsMapped = cards?.map((card, index) => {
    const { heading, text, link } = card
    return (
      <Col key={index} md={colClass}>
        <CardMinor
          headingSize="h2"
          title={heading}
          text={text}
          url={link?.url}
          internalLink={true}
        />
      </Col>
    )
  })

  return (
    <section className="base-margin-top-large base-margin-bottom-large">
      <Row className="mobile-bottom-margins">{cardsMapped}</Row>
    </section>
  )
}

export const query = graphql`
  fragment CardMinorGrid on WpBlockAcfCardMinorGrid {
    __typename
    blockDataCardMinorGrid {
      cards {
        heading
        text
        link {
          url
          title
          target
        }
      }
    }
  }
`

export default CardMinorGrid
